import { render, staticRenderFns } from "./ExportarListaDeItensSeparacaoDeMercadoria.vue?vue&type=template&id=35c7b01f"
import script from "./ExportarListaDeItensSeparacaoDeMercadoria.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportarListaDeItensSeparacaoDeMercadoria.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports